import { render, staticRenderFns } from "./GemsPlansList.vue?vue&type=template&id=6f30f0f6&"
import script from "./GemsPlansList.vue?vue&type=script&lang=js&"
export * from "./GemsPlansList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports